import cn from '@/lib/cs';
import React from 'react';

const PlayIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M21.8 10.1a232.6 232.6 0 01-3.9-3.4L13.1 4 10 1.5 8 1l-1 .9.2 1.2c0 6.2.4 10.3-.3 17.6l.7 2.3 2.7-.4 5.5-4.8 5-3.6 2.1-2.4-1.2-1.7z"
		/>
	</svg>
);

export default PlayIcon;
